import LanguageSwitcher, { ILanguageOption } from './LanguageSwitcher';

export type { ILanguageOption };
export default LanguageSwitcher;
